import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie';

import { AuthService } from '../../services/auth.service';
import { SocketService } from '../../services/socket.service';

@Component({
	selector: 'app-backend',
	templateUrl: './backend.component.html',
	styleUrls: ['./backend.component.css']
})
export class BackendComponent implements OnInit {
	arit: boolean = false;
	josso_username: string;
	josso_password: string;

	constructor(
		private authService: AuthService,
		private router: Router,
		private cookieService: CookieService,
		private socketService: SocketService
		) { }

	ngOnInit() {
		if ( this.authService.loggedIn() ) {
			this.router.navigate(['/profilo-utente']);
		}
	}

	onLoginSubmit() {
		this.authService.loggingOut = false;
		let login = {
			username : this.josso_username,
			password : this.josso_password
		}
		//console.log('LOGIN', login);

		this.authService.authenticateUser(login).subscribe(
			data => {
				console.log('LOGIN RESPONSE', data);
				if (data.success) {
					console.log('LOGIN SUCCESS');
					this.authService.storeUserData(data.token,data.user);
					// this.socketService.sendUserId(data.user.id);
					this.router.navigate(['/profilo-utente']);
					// LOGIN SUCCESS
				}else {
					// LOGIN ERROR
					this.authService.openMessage('ERRORE LOGIN','username e/o password errati:'+login.username);
					this.router.navigate(['/backend']);
				}
			}
		);
	}

	goToRegister() {
		this.router.navigate(['/register']);
	}

	backToLogin() {
		//console.log("CMP|BACKEND - navigate login");
		this.router.navigate(['/login']);
	}
}
